import { render } from "./FeedbackFour.vue?vue&type=template&id=50348d9e"
import script from "./FeedbackFour.vue?vue&type=script&lang=js"
export * from "./FeedbackFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__